import script from "./SettingsChangelogFiltersBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsChangelogFiltersBar.vue?vue&type=script&setup=true&lang=js"

import "./SettingsChangelogFiltersBar.vue?vue&type=style&index=0&id=0b049b90&scoped=true&lang=css"
import "./SettingsChangelogFiltersBar.vue?vue&type=style&index=1&id=0b049b90&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b049b90"]])

export default __exports__